import { render, staticRenderFns } from "./configuration-automation-assays-grid.vue?vue&type=template&id=4ca9db7c&"
import script from "./configuration-automation-assays-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-automation-assays-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports